

<template>
  <div class="col-span-12 py-5 rounded-sm border border-stroke bg-white px-5 pt-7.5 pb-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:col-span-8">
    <HeaderPartial
      title="Déclaration d'accessibilité"
    />
  
    <main class="">
      <div class="mx-auto max-w-7xl px-6 lg:px-8 mt-10">
        <div>
          <div class="max-w-4xl mx-auto py-8 px-4 bg-white rounded-lg">
            <p class="mt-4">
              La Fédération Wallonie-Bruxelles s'efforce de rendre ses sites internet et ses applications mobiles accessibles, conformément au <a
                href="https://www.gallilex.cfwb.be/fr/leg_res_02.php?ncda=47101&amp;referant=l01"
                target="_blank"
                class="link-external-blank"
                rel="noreferrer"
              >décret du Parlement de la Communauté française du &nbsp;3 mai 2019 portant sur l'accessibilité des sites internet et des applications mobiles des organismes publics</a> et à <a
                href="http://www.ejustice.just.fgov.be/cgi/article_body.pl?language=fr&amp;pub_date=2018-09-03&amp;caller=summary&amp;numac=2018040577"
                target="_blank"
                class="link-external-blank"
                rel="noreferrer"
              >la loi du 19 juillet 2018 d'accessibilité des sites Web et des applications mobiles des autorités publiques</a> transposant <a
                href="http://bdf.belgium.be/resource/static/files/import/2017_05_23_access/legal-content-fr.pdf"
                target="_blank"
                class="link-external-blank"
                rel="noreferrer"
              >la Directive (UE) 2016/2102</a> du Parlement européen et du Conseil.<br> 
            </p>
            <p class="mb-4">
              La présente déclaration sur l’accessibilité s'applique au site suivant : <a
                href="https://subventions.datawb.be/"
                target="_blank"
              >https://subventions.datawb.be/</a>
            </p>
             
           
            <h1 class="text-3xl font-semibold mb-4 text-gray-800">
              Niveau de conformité
            </h1>
            <p class="mb-4">
              Ce site internet est en conformité partielle avec les standards <abbr title="Web Content Accessibility Guidelines">WCAG</abbr> 2.1 niveau AA.
            </p>

            <h2 class="text-2xl font-semibold mb-4 text-gray-800">
              Préparation de la déclaration
            </h2>
            <p class="mb-4">
              Un audit interne de l'accessibilité a été effectué. Cet audit consistait en une analyse simplifiée.
            </p>
            <p class="mb-4">
              La présente déclaration a été préparée le <span class="font-semibold">30 juillet 2024</span> après utilisation des méthodes suivantes :
            </p>

            <ul class="list-disc list-inside mb-4">
              <li>Audit AXE</li>
              <li>Vérification manuelle</li>
            </ul>

            <p class="mb-4">
              Date de la dernière mise à jour de la déclaration : <span class="font-semibold">09/06/2026</span>.
            </p>

            <h2 class="text-2xl font-semibold mb-4 text-gray-800">
              Contenu non accessible
            </h2>

            <div class="space-y-6">
              <div>
                <h3 class="text-xl font-semibold text-gray-700">
                  Navigation au clavier
                </h3>
                <p>L’ordre de navigation au clavier doit être amélioré car il n'est pas identique à une navigation de type visuelle. Certains éléments ne sont pas cliquables au clavier.</p>
              </div>

              <div>
                <h3 class="text-xl font-semibold text-gray-700">
                  Alternative textuelle pour les images
                </h3>
                <p>Certaines images à valeur informative n’ont pas d’alternative textuelle ou pas d’alternative textuelle suffisante ou significative.</p>
              </div>

              <div>
                <h3 class="text-xl font-semibold text-gray-700">
                  Hiérarchie des titres (H1 à H6)
                </h3>
                <p>La hiérarchie des titres doit être optimisée car elle ne permet pas une navigation significative au travers des titres.</p>
              </div>

              <div>
                <h3 class="text-xl font-semibold text-gray-700">
                  Contrastes de couleurs
                </h3>
                <p>Le contraste entre la couleur d'avant-plan (texte/visuel) et la couleur d’arrière-plan n’est pas suffisant dans certains écrans.</p>
              </div>

              <div>
                <h3 class="text-xl font-semibold text-gray-700">
                  Liste
                </h3>
                <p>Les éléments de listes ne sont pas contenus dans des listes sémantiques.</p>
              </div>

              <div>
                <h3 class="text-xl font-semibold text-gray-700">
                  Iframe
                </h3>
                <p>Certains iframes ne contiennent pas de titre.</p>
              </div>

              <div>
                <h3 class="text-xl font-semibold text-gray-700">
                  Informations relayées par la couleur
                </h3>
                <p>Les informations relayées par la couleur doivent offrir une alternative à l'attention des personnes ne discernant pas les couleurs.</p>
              </div>

              <div>
                <h3 class="text-xl font-semibold text-gray-700">
                  Navigation avec lecteur d'écran
                </h3>
                <p>Certains éléments ne sont pas lus par un lecteur d'écran.</p>
              </div>
            </div>

            <h2 class="text-2xl font-semibold mt-8 mb-4 text-gray-800">
              Retour d'information et coordonnées de contact
            </h2>
            <p class="mb-4">
              Si vous ne pouvez prendre connaissance de certains contenus en raison de leur inaccessibilité, vous pouvez écrire à l'adresse : <a
                href="mailto:data.office@cfwb.be"
                class="text-indigo-600 hover:underline"
              >data.office@cfwb.be</a>.
            </p>

            <h2 class="text-2xl font-semibold mt-8 mb-4 text-gray-800">
              Procédure permettant d'assurer le respect des dispositions
            </h2>
            <p class="mb-4">
              En cas de non réponse dans les 30 jours ou de réponse insatisfaisante du gestionnaire du site, nous vous invitons à adresser un mail au Service de médiation commun à la Communauté française et à la Région wallonne via l’adresse : <a
                href="mailto:courrier@le-mediateur.be"
                class="text-indigo-600 hover:underline"
              >courrier(at)le-mediateur.be</a>. Dans votre message, vous pouvez indiquer le nom du site web concerné de même que le problème rencontré.
            </p>

            <h2 class="text-2xl font-semibold mt-8 mb-4 text-gray-800">
              Plan d'amélioration
            </h2>
            <p class="mb-4">
              Afin d'atteindre une conformité totale aux standards <abbr title="Web Content Accessibility Guidelines">WCAG</abbr> 2.1 niveau AA, les actions correctives suivantes sont planifiées pour les points relevés dans la section « Contenu non accessible » :
            </p>
            <ul class="list-disc list-inside mb-4 space-y-2">
              <li>Révision de l'ordre de tabulation et de la navigation au clavier afin qu'il corresponde à l'ordre visuel et que tous les éléments interactifs soient accessibles au clavier.</li>
              <li>Ajout ou correction des alternatives textuelles pour l'ensemble des images à valeur informative.</li>
              <li>Optimisation de la hiérarchie des titres (H1 à H6) pour permettre une navigation structurée et significative.</li>
              <li>Renforcement des contrastes de couleurs entre le texte/les visuels et l'arrière-plan afin d'atteindre les ratios minimaux requis.</li>
              <li>Intégration des éléments de listes dans des listes sémantiques (&lt;ul&gt;, &lt;ol&gt;).</li>
              <li>Ajout d'un titre descriptif à l'ensemble des iframes.</li>
              <li>Ajout d'alternatives aux informations relayées uniquement par la couleur.</li>
              <li>Correction des éléments non restitués par les lecteurs d'écran.</li>
            </ul>
            <p class="mb-4">
              Ces corrections sont menées en collaboration avec notre partenaire informatique. Leur mise en œuvre est planifiée d'ici la fin de l'année <span class="font-semibold">2026</span>. La présente déclaration sera actualisée au minimum une fois par an pour rendre compte de l'avancement.
            </p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
    

    
